import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayTypeOPEEnum} from "./GatewayTypeOPEEnum";

class GatewayTypeDTO {
  id!: number;
  modelName!: string;
  partNumber?: string;
  osType!: string;
  additionalInfo?: GatewayTypeAdditionalInfoDTO;
}

class GatewayTypeAdditionalInfoDTO {
  rtuPorts?: string[];
}

class O {
  gatewayTypes!: GatewayTypeDTO[];
}

/**
 * O Inner Class
 */
class I {
}

export class GetGatewayTypesCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(GatewayTypeOPEEnum.GetGatewayTypes);
    this.i = new I();
    this.o = new O();
  }
}
